import React from 'react';
import './App-modern.scss';
import { Route, Routes } from 'react-router';
import Login from './pages/Login/Login';
import NewRecepisse from './pages/NewRecepisse/NewRecepisse';
import RecepisseDetails from './pages/RecepisseDetails/RecepisseDetails';
import { useRecoilState } from 'recoil';
import { UserInfoStateRecoil } from './utilities/globaleState';
import { isObjectEmpty } from './utilities/helpers';
import NavBar from './components/NavBar/NavBar';
import Liste from './pages/Liste/Liste';
import Footer from './components/Footer/Footer';
import { ProtectedRoute } from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard/Dashboard';
function App() {
  const [userInfoState] = useRecoilState(UserInfoStateRecoil);
  const isLoggedIn = !isObjectEmpty(userInfoState);

  return (
    <div className="App">
       {isLoggedIn && <NavBar />}
       <div className={isLoggedIn ? "App__content" : "App__content App__content--full"}>
          <Routes>
             <Route path='/' element={<Login />}/>
             <Route path='/tableau-board' element={
               <ProtectedRoute>
                 <Dashboard />
               </ProtectedRoute>
             } />
             <Route path='/newrecepisse' element={
               <ProtectedRoute>
                 <NewRecepisse />
               </ProtectedRoute>
             } />
             <Route path='/recepissedetails/:id' element={
               <ProtectedRoute>
                 <RecepisseDetails />
               </ProtectedRoute>
             }/>
             <Route path='/liste' element={
               <ProtectedRoute>
                 <Liste />
               </ProtectedRoute>
             }/>
          </Routes>
          <Footer />
       </div>
    </div>
  );
}

export default App;
